module.exports = __webpack_public_path__ + "static/media/GT-Walsheim-Bold.261b2002.woff";